import countBy from 'lodash/countBy';
import validUrl from 'valid-url';
export const validate = (values) => {
    const errors = {};
    if (!values.routes || !values.routes.length) {
        return {
            _error: 'At least one URL must be added - click on "Add URL"',
        };
    }
    const routes = values.routes.map((route) => (Object.assign({ urlPrefix: '' }, route)));
    const routeErrors = [];
    routes.forEach((route, index) => {
        if (!route.urlPrefix.trim()) {
            routeErrors[index] = { urlPrefix: 'Required' };
        }
        else if (!validUrl.isWebUri(route.urlPrefix)) {
            routeErrors[index] = {
                urlPrefix: 'Please add a valid URL - must start with "http://" or "https://"',
            };
        }
    });
    const counts = countBy(routes, (route) => route.urlPrefix);
    routes.forEach(({ urlPrefix }, index) => {
        if (counts[urlPrefix] > 1 && urlPrefix.length > 0) {
            routeErrors[index] = {
                urlPrefix: "You can't have duplicate URLs",
            };
        }
    });
    if (routeErrors.length) {
        errors.routes = routeErrors;
    }
    return errors;
};
